<template>
  <ListItem class="list-button">
    <DarwinButton
      class="list-button__darwin-button"
      flair="rounded"
      kind="transparent"
      size="xs"
    >
      <slot />
    </DarwinButton>
  </ListItem>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import DarwinButton from '@/uiKit/Button/DarwinButton.vue'

import ListItem from './ListItem.vue'

export default defineComponent({
  name: 'ListButton',
  components: { ListItem, DarwinButton },
})
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/index.scss';

.list-button {
  padding: 4px;

  &__darwin-button {
    width: 100%;
    height: fit-content;
    display: inline-block;
    border: 0;
    border-radius: inherit;
    padding: $spacing-4 $spacing-3;
    text-align: unset;
    color: inherit;
  }
}
</style>
